import { render, staticRenderFns } from "./AppleWidget.vue?vue&type=template&id=5e4186bd&scoped=true&"
import script from "./AppleWidget.vue?vue&type=script&lang=js&"
export * from "./AppleWidget.vue?vue&type=script&lang=js&"
import style0 from "./AppleWidget.vue?vue&type=style&index=0&id=5e4186bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4186bd",
  null
  
)

export default component.exports